module.exports = __webpack_public_path__ + "img/Sari-Kaufman.b8237183.jpg";